package com.ilussobsa.sdk

import com.ilussobsa.*
import com.ilussobsa.views.LogInScreen
import com.lightningkite.UUID
import com.lightningkite.kiteui.navigation.mainPageNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.lightningserver.auth.accessToken
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import kotlin.coroutines.cancellation.CancellationException

class UserSession(
    val api: Api2,
    val userId: UUID,
) : CachedApi2(api, consoleAndRecorded) {

    val me = remember { user[userId]() }
}

val currentUserSessionNullable = rememberSuspending {
    val refresh = refreshToken()
    val api = selectedApi().api

    if (refresh != null) {
        val defaultHeaderCalculator = api.userAuth.accessToken(refresh)
        val masqueradeAsId = masqueradeUserId()
        val authApi = api.withHeaderCalculator {
            if (masqueradeAsId?.isNotEmpty() == true) {
                defaultHeaderCalculator() + ("X-Masquerade" to "User/$masqueradeAsId")
            } else {
                defaultHeaderCalculator()
            }
        }
        val self = authApi.userAuth.getSelf()
        UserSession(
            authApi,
            masqueradeAsId?.takeIf { it.isNotEmpty() }?.let(UUID::parse) ?: self._id
        )
    } else null
}

val ViewWriter.currentUserSession get() = remember {
    val result = currentUserSessionNullable()
    if (result == null) {
        if (mainPageNavigator.stack.value.lastOrNull() !is LogInScreen) {
            println("Kicking ya out!")
            mainPageNavigator.reset(LogInScreen())
        }
        throw CancellationException("Failed")
    }
    result
}

val currentSession = remember {
    currentUserSessionNullable() ?: CachedApi2(selectedApi().api, consoleAndRecorded)
}

//suspend fun ViewWriter.clearSession() {
//    try {
//        currentSession.await()?.userSession?.terminateSession()
//    } catch (e: Exception) {
//        /*squish*/
//    }
//    println("Session cleared")
//    sessionToken set null
//}


val refreshToken = PersistentProperty<String?>("sessionToken", null)
val masqueradeUserId = PersistentProperty<String?>("masqueradeUserId", null)

val currentUser = remember { currentUserSessionNullable()?.me() }
val isSeller = remember { currentUser()?.role?.let { it >= UserRole.Manager } ?: false }
val participatesInAuctions = remember { (currentUser()?.role ?: UserRole.Anonymous) == UserRole.Customer }
val managesAuctions = remember { (currentUser()?.role ?: UserRole.Anonymous) >= UserRole.Manager }
